import { useState, useEffect } from 'react';
import { cn } from '@/utils';
import { useDimensions } from '@/hooks/useDimensions';

interface StrengthOption {
  label: string;
  price: number;
  value: string;
}

interface StrengthToggleProps {
  options: StrengthOption[];
  defaultValue?: string;
  onChange?: (value: string) => void;
  className?: string;
  forceUpdateKey?: string | number;
}

export default function StrengthToggle({
  options,
  defaultValue = options[0]?.value,
  onChange,
  className,
  forceUpdateKey,
}: StrengthToggleProps) {
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  useEffect(() => {
    if (defaultValue) {
      setSelectedValue(defaultValue);
    }
  }, [defaultValue, forceUpdateKey]);

  const handleSelect = (option: StrengthOption) => {
    setSelectedValue(option.value);
    onChange?.(option.value);
  };

  const { isMobileOrPad } = useDimensions();

  const strengthLabel = ['Low Strength', 'High Strength'];

  return (
    <div className={cn('flex w-full overflow-hidden rounded-lg border-2 border-gray-200 bg-gray-100', className)}>
      {options.map((option, index) => {
        const isSelected = selectedValue === option.value;
        return (
          <button
            key={option.value}
            type="button"
            className={cn(
              'flex-1 py-4 px-2 text-center font-medium text-2xl transition-colors',
              isSelected ? 'bg-white text-black rounded-lg' : 'bg-transparent text-gray-600',
              index === 0 ? 'rounded-l-lg' : '',
              index === options.length - 1 ? 'rounded-r-lg' : '',
            )}
            onClick={() => handleSelect(option)}
          >
            {strengthLabel[index]} - ${option.price.toFixed(2)}
          </button>
        );
      })}
    </div>
  );
}
